import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class RsaService {

  encryptMode: boolean;
  textToConvert: string;
  password = 'Shine@321';
  conversionOutput: string;

  constructor() { }

  encrypt(textToConvert) {
    if(textToConvert)
    return this.conversionOutput = CryptoJS.AES.encrypt(textToConvert.trim(), this.password.trim()).toString();
    else return ''
  }

  decrypt(textToConvert) {
    if(textToConvert)
    return this.conversionOutput = CryptoJS.AES.decrypt(textToConvert.trim(), this.password.trim()).toString(CryptoJS.enc.Utf8);
    else return ''
  }
}
